import NotificationList from "./notification-list.component";

export default NotificationList;
